// src/services/azureTableUtils.js
// Utility to ensure Azure Table Storage tables exist before use

const STORAGE_ACCOUNT = "mfprojects";
const SAS_TOKEN =
  "sv=2024-11-04&ss=t&srt=sco&sp=rwdlacu&se=2035-07-04T17:08:25Z&st=2025-07-04T09:08:25Z&spr=https&sig=X7s%2BFIyYcKvRzSxRNAp5BUJEe2YUcg8nojkn9fIfcTY%3D";

const ensuredTables = new Set();

/**
 * Ensures an Azure Table exists, creating it if necessary.
 * Results are cached in-memory so each table is only checked once per session.
 */
export async function ensureTableExists(tableName) {
  if (ensuredTables.has(tableName)) return;

  const url = `https://${STORAGE_ACCOUNT}.table.core.windows.net/Tables?${SAS_TOKEN}`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json;odata=nometadata",
    },
    body: JSON.stringify({ TableName: tableName }),
  });

  if (response.ok || response.status === 409) {
    // 409 = table already exists, that's fine
    ensuredTables.add(tableName);
    return;
  }

  const errorText = await response.text();
  console.error(`Failed to ensure table "${tableName}":`, response.status, errorText);
  throw new Error(`Could not create table "${tableName}": ${response.status}`);
}
